export default "__VITE_ASSET__Cy$f6ZyS__"